// Same wording/maths as the app's profile page "Unlock Circle Membership"
// card (btcappdec .../Profile/circleEligibilityProgress.ts), so the progress a
// customer sees here matches what the app shows.
const amount = (value) => {
  const n = Number(value) || 0;
  return n.toLocaleString("en-IN", { maximumFractionDigits: n % 1 === 0 ? 0 : 2 });
};

const clamp = (value) => Math.max(0, Math.min(100, value));

export const circleProgressPercent = (p) => {
  const visits = Math.max(0, Number(p?.visitCount) || 0);
  const requiredVisits = Math.max(1, Number(p?.requiredVisitCount) || 2);
  const spend = Math.max(0, Number(p?.totalSpend) || 0);
  const requiredSpend = Math.max(1, Number(p?.requiredSpend) || 2000);
  return Math.round((clamp((visits / requiredVisits) * 100) + clamp((spend / requiredSpend) * 100)) / 2);
};

export const circleProgressRemainingLine = (p) => {
  const days = Math.max(0, Number(p?.remainingVisitCount) || 0);
  const end = String(p?.eligibilityWindowEndDateText || "").trim();
  return `${days} more order ${days === 1 ? "day" : "days"} and ₹${amount(p?.remainingSpend)} more to go${end ? ` by ${end}` : ""}`;
};

export const circleProgressSummary = (p) => ({
  orderDays: `${Math.max(0, Number(p?.visitCount) || 0)}/${Math.max(0, Number(p?.requiredVisitCount) || 2)} days`,
  spend: `₹${amount(p?.totalSpend)}/₹${amount(p?.requiredSpend || 2000)}`,
});
